import { ENUM_ERROR } from './client';

export const ERROR_CODE_PAIR = {
  [ENUM_ERROR.PARAM_INVALID]: 400,
  [ENUM_ERROR.NOT_EXIST]: 404,
  [ENUM_ERROR.TIMEOUT]: 504,
}